import React from 'react';

const Games = () => (
  <div>
    <h2>Games</h2>
    <p>List of developed games.</p>
  </div>
);

export default Games;
